import PropTypes from 'prop-types';

export const RedirectPropType = PropTypes.shape({
  from: PropTypes.string,
  to: PropTypes.string,
});

export const RedirectsPropType = PropTypes.arrayOf(RedirectPropType);
